/**------------------------------------------------------
 * Enum Definitions
 */
export enum EnumNgDatePickerTextAlignMent {
	Start 	= 'start',
	Center 	= 'center',
	End 	= 'end'
}


/**------------------------------------------------------
 * Interfaces
 */
export interface INgDatePickerOptions {
	minDate			: Date;
	maxDate			: Date;
	disableDates	: Date[];
}

export interface INgDateRange {
	startDate		: Date;
	endDate			: Date;
}
